import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapActions } from "vuex";
import api from "../../api";
import { LoginActionPayload } from "../../store/actions";
import * as types from "../../store/types";
import { ChangeInitPasswordModal } from "@account/components/modal"

@Component({
    methods: {
        ...mapActions({
            // login: types.LOGIN,
            login: types.EUMLOGIN,
        }),
    },
    components: {
        ChangeInitPasswordModal
    }
})
export default class LoginView extends Vue {
    login!: (payload: LoginActionPayload) => Promise<account.TCurrent>;

    username: string = "";
    password: string = "";
    rememberMe: boolean = false;
    errors: string[] = [];
    defaultPwd: string = "Pa$$w0rd";

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.username = localStorage.username;
        this.rememberMe = localStorage.rememberMe === "true";
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async handleLogin(e: Event) {
        e.preventDefault();
        this.errors = [];
        if (!this.checkForm(e)) throw new Error("[LOGIN_CANCELED_ERROR]");
        const { username, password, rememberMe } = this;
        try {
            const result = await this.login({ username, password });
            localStorage.username = rememberMe ? username : "";
            localStorage.rememberMe = rememberMe;

            const { returnUrl, ...etc } = this.$route.query;
            console.log("returnUrl : " + returnUrl);
            if (returnUrl && typeof returnUrl === "string") {
                this.$router.push({
                    path: decodeURIComponent(returnUrl),
                    query: etc,
                });
            } else {
                this.$router.push({
                    path: "/",
                    query: etc,
                });
            }
        } catch (e) {
            const serverErrors = (e as any).data?.errors;
            if (serverErrors) {
                this.errors = [...this.errors, ...serverErrors];
            } else {
                this.errors.push(e as any);
            }
        }
    }

    checkForm(e: Event): boolean {
        this.errors = [];

        if (!this.username) {
            this.errors.push(this.$t("아이디를_입력하세요").toString());
        }
        if (this.username?.indexOf("@") != -1 && !this.validEmail(this.username)) {
            this.errors.push(this.$t("올바른_이메일_형식이_아닙니다").toString());
        } else if (!this.password) {
            this.errors.push(this.$t("암호가_필요합니다").toString());
        }
        if (this.password == this.defaultPwd) {
            this.errors.push(this.$t("초기비밀번호입니다__비밀번호_변경이_필요합니다").toString());
            this.changePassword();
        }

        if (this.errors.length) {
            return false;
        } else {
            e.preventDefault();
            return true;
        }
    }

    validEmail(email: string): boolean {
        var re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    openChangeInitPasswordModal(){
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any;
        const options: appbase.TModalInfo<any> = {
            component: ChangeInitPasswordModal,
            props: {
                username: this.username
            },
            events: {
                save: () => {
                    (window as any).alertAsync(this.$t("비밀번호_변경이_완료되었습니다").toString());
                    modal.closeModal()
                },
                cancel: () => {
                    modal.closeModal()
                }
            }
        }

        modal.openModal(options);
    }

    async changePassword() {
        await (window as any).alertAsync(this.$t("초기비밀번호입니다__비밀번호_변경이_필요합니다").toString());

        this.openChangeInitPasswordModal();
    }
}
